export function getElementsByText(label: string): HTMLElement[] {
  const elements: NodeListOf<Element> = document.querySelectorAll("button, a");
  const matches: HTMLElement[] = [];

  for (const element of elements) {
    if (
      (element as HTMLElement).innerText
        .toLowerCase()
        .includes(label.toLowerCase())
    ) {
      matches.push(element as HTMLElement);
    }
  }

  return matches;
}
